import React from 'react';
import {
  Box,
  Button,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { LocalChatSession } from '../../../../hooks/ai-hooks';

type Props = {
  sessions: LocalChatSession[];
  selectedSessionId: string | null;
  onSelect: (sessionId: string) => void;
  onNew: () => void;
  onRemove: (sessionId: string) => void;
};

const ChatSessionsPanel: React.FC<Props> = ({
                                              sessions,
                                              selectedSessionId,
                                              onSelect,
                                              onNew,
                                              onRemove,
                                            }) => {
  return (
    <Paper elevation={1} sx={{ p: 2 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
        <Box>
          <Typography variant="h6">Chats</Typography>
          <Typography variant="caption" color="text.secondary">
            Local index of recent server-backed sessions
          </Typography>
        </Box>

        <Button size="small" variant="contained" startIcon={<AddIcon />} onClick={onNew}>
          New
        </Button>
      </Stack>

      <List dense sx={{ maxHeight: 620, overflow: 'auto', p: 0 }}>
        {sessions.map((session) => (
          <ListItemButton
            key={session.session_id}
            selected={selectedSessionId === session.session_id}
            onClick={() => onSelect(session.session_id)}
            sx={{
              borderRadius: 1,
              mb: 0.75,
              border: '1px solid',
              borderColor:
                selectedSessionId === session.session_id ? 'primary.main' : 'divider',
            }}
          >
            <ListItemText
              primary={session.title || 'New chat'}
              secondary={new Date(session.updated_at).toLocaleString()}
              primaryTypographyProps={{ noWrap: true, fontWeight: 600 }}
              secondaryTypographyProps={{ variant: 'caption' }}
            />

            <Button
              color="inherit"
              size="small"
              onClick={(event) => {
                event.stopPropagation();
                if (window.confirm('Remove this chat from your local list? Server history remains.')) {
                  onRemove(session.session_id);
                }
              }}
            >
              <DeleteOutlineIcon fontSize="small" />
            </Button>
          </ListItemButton>
        ))}

        {!sessions.length ? (
          <Typography variant="body2" color="text.secondary">
            No chats yet.
          </Typography>
        ) : null}
      </List>
    </Paper>
  );
};

export default ChatSessionsPanel;